// extracted by mini-css-extract-plugin
export default {"filter":"company_filter_filter__OfJrQ","Mui-focused":"company_filter_Mui-focused__NHNML","label":"company_filter_label__ETC72"};